module.exports = __webpack_public_path__ + "img/Image_002.fcdeeebd.png";